import styled from 'styled-components';

export const CardContentContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-bottom: -10px;
`;

export const CardContentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  span {
    font-weight: 600;
    font-size: 16px;
  }
`;

export const SelectAllWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 10;
`;
